var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id },
    },
    [
      _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "box-shadow" },
            [
              _c(
                "div",
                { staticClass: "thumb-image" },
                [
                  _c(
                    "div",
                    { staticClass: "prop-1-1" },
                    [
                      _vm._t("item-image", function () {
                        return [
                          _c("category-image-carousel", {
                            ref: "categoryImageCarousel",
                            attrs: {
                              "image-urls-data": _vm._f("itemImages")(
                                _vm.item.images,
                                _vm.imageUrlAccessor
                              ),
                              alt: _vm._f("itemName")(_vm.item),
                              "item-url": _vm._f("itemURL")(
                                _vm.item,
                                _vm.urlWithVariationId
                              ),
                              "enable-carousel": false,
                              "disable-carousel-on-mobile": true,
                            },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.stoffparent != null
                    ? [
                        _c("span", { staticClass: "producer" }, [
                          _vm._v(
                            "\n                      " +
                              _vm._s(
                                _vm.$translate("Stoffe::Template.catManyColors")
                              ) +
                              "\n                  "
                          ),
                        ]),
                      ]
                    : _vm.showproducer != null
                    ? [
                        _c("span", { staticClass: "producer" }, [
                          _vm._v(
                            "\n                      " +
                              _vm._s(
                                _vm.$translate("Stoffe::Template.singleAuthor")
                              ) +
                              " " +
                              _vm._s(_vm.showproducer) +
                              "\n                  "
                          ),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _vm.isSoldOut
                ? [
                    _c("div", { staticClass: "special-tags" }, [
                      _c(
                        "span",
                        { staticClass: "badge badge-offer badge-danger" },
                        [
                          _vm._v(
                            "\n                      " +
                              _vm._s(
                                _vm.$translate(
                                  "Stoffe::Template.globalCatAusverkauft"
                                )
                              ) +
                              "\n                  "
                          ),
                        ]
                      ),
                    ]),
                  ]
                : [
                    _vm._t("store-special", function () {
                      return [
                        _vm.storeSpecial ||
                        _vm.item.variation.bundleType === "bundle" ||
                        _vm.item.item.itemType === "set"
                          ? _c("item-store-special", {
                              attrs: {
                                "store-special": _vm.storeSpecial,
                                "recommended-retail-price": _vm.item.prices.rrp,
                                "variation-retail-price":
                                  _vm.item.prices.default,
                                "special-offer-price":
                                  _vm.item.prices.specialOffer,
                                "decimal-count": _vm.decimalCount,
                                "bundle-type": _vm.item.variation.bundleType,
                                "item-type": _vm.item.item.itemType,
                              },
                            })
                          : _vm._e(),
                      ]
                    }),
                  ],
              _vm._v(" "),
              _c("div", { staticClass: "thumb-content" }, [
                _c(
                  "a",
                  {
                    staticClass: "thumb-title",
                    class: {
                      "stretched-link":
                        _vm.$ceres.config.global.shippingCostsCategoryId == 0,
                    },
                    attrs: {
                      href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId),
                    },
                  },
                  [
                    _vm._v(
                      "\n                  " +
                        _vm._s(_vm._f("itemName")(_vm.item))
                    ),
                    _vm._l(_vm.item.groupedAttributes, function (attribute) {
                      return _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("translate")(
                              "Ceres::Template.itemGroupedAttribute",
                              attribute
                            )
                          )
                        ),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "thumb-meta mt-2" },
            [
              _vm._t("before-prices"),
              _vm._v(" "),
              _c("div", { staticClass: "prices" }, [
                _vm.item.prices.rrp &&
                _vm.item.prices.rrp.price.value > 0 &&
                _vm.item.prices.rrp.price.value >
                  _vm.item.prices.default.price.value
                  ? _c("div", { staticClass: "price-view-port" }, [
                      _vm.item.prices.specialOffer
                        ? _c("del", { staticClass: "crossprice" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("itemCrossPrice")(
                                    _vm.item.prices.default.unitPrice.formatted,
                                    true
                                  )
                                ) +
                                "\n            "
                            ),
                          ])
                        : _c("del", { staticClass: "crossprice" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("itemCrossPrice")(
                                    _vm.item.prices.rrp.unitPrice.formatted
                                  )
                                ) +
                                "\n            "
                            ),
                          ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "price" },
                  [
                    _vm.item.item.itemType === "set"
                      ? [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$translate("Ceres::Template.itemSetPrice", {
                                  price: _vm.itemSetPrice,
                                })
                              ) +
                              " " +
                              _vm._s(
                                _vm.$translate("Ceres::Template.itemFootnote")
                              ) +
                              "\n            "
                          ),
                        ]
                      : _vm.itemGraduatedPriceisCheapestSorting
                      ? [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.itemFromPrice",
                                  { price: _vm.itemPriceGraduated }
                                )
                              ) +
                              " " +
                              _vm._s(
                                _vm.$translate("Ceres::Template.itemFootnote")
                              ) +
                              "\n            "
                          ),
                        ]
                      : _vm.itemGraduatedPricesalableVariationCount
                      ? [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.itemFromPrice",
                                  { price: _vm.itemPriceGraduated }
                                )
                              ) +
                              " " +
                              _vm._s(
                                _vm.$translate("Ceres::Template.itemFootnote")
                              ) +
                              "\n            "
                          ),
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("specialOffer")(
                                  _vm.item.prices.default.unitPrice.formatted,
                                  _vm.item.prices,
                                  "unitPrice",
                                  "formatted"
                                )
                              ) +
                              " " +
                              _vm._s(
                                _vm.$translate("Ceres::Template.itemFootnote")
                              ) +
                              "\n            "
                          ),
                        ],
                  ],
                  2
                ),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("after-prices"),
          _vm._v(" "),
          _vm.item.prices.default.lowestPrice.value && _vm.hasCrossPrice
            ? _c("div", { staticClass: "category-lowest-price small" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$translate("Ceres::Template.itemLowestPrice", {
                        price: _vm.item.prices.default.lowestPrice.formatted,
                      })
                    ),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          !(
            _vm.item.unit.unitOfMeasurement === "C62" &&
            _vm.item.unit.content === 1
          )
            ? _c("div", { staticClass: "category-unit-price small" }, [
                _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                _vm._v(" "),
                _c("span", [_vm._v(" " + _vm._s(_vm.item.unit.names.name))]),
                _vm._v(" "),
                _vm.item.variation.mayShowUnitPrice
                  ? _c("span", [_vm._v(" | " + _vm._s(_vm.basePrice))])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }